export enum ButtonColor {
    Primary = 'primary',
    Secondary = 'secondary',
}

export enum ButtonSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export interface IButtonProps {
    text: string;
    color: ButtonColor;
    size: ButtonSize;
    onClick: () => void;
}